import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Download, Edit, Trash } from "react-feather";
import * as XLSX from 'xlsx';
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AdminAllEnquiry = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [filteredEnquiries, setFilteredEnquiries] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [currentEdit, setCurrentEdit] = useState(null);
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState("Active");

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllProductEnquiries`);
      const data = response.data.data || [];
      setEnquiries(data);
      setFilteredEnquiries(data);
    } catch (error) {
      console.error("Error fetching enquiries:", error);
      Swal.fire("Error", "Failed to load enquiries", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let filtered = [...enquiries];

    if (search) {
      filtered = filtered.filter(e =>
        e.name?.toLowerCase().includes(search.toLowerCase()) ||
        e.email?.toLowerCase().includes(search.toLowerCase()) ||
        e.phone?.includes(search) ||
        e.message?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (startDate && endDate) {
      filtered = filtered.filter(e => {
        const enquiryDate = new Date(e.created_at);
        return enquiryDate >= startDate && enquiryDate <= endDate;
      });
    }

    setFilteredEnquiries(filtered);
  }, [search, startDate, endDate, enquiries]);

  const handleDownloadExcel = () => {
    const dataToExport = filteredEnquiries.map(e => ({
      "Name": e.name,
      "Email": e.email,
      "Phone": e.phone,
      "Message": e.message,
      "Listing ID": e.listing_id,
      "Seller ID": e.seller_id,
      "Date": new Date(e.created_at).toLocaleString()
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All Enquiries");
    XLSX.writeFile(wb, "product_enquiries.xlsx");
  };

  const openEditModal = (enquiry) => {
    setCurrentEdit(enquiry);
    setRemark(enquiry.remark || "");
    setStatus(enquiry.status || "Active");
    setShowModal(true);
  };

  const handleEditSubmit = async () => {
    try {
      await axios.post(`${baseurl}updateProductEnquiry`, {
        id: currentEdit.id,
        remark,
        status,
      });
      Swal.fire("Updated", "Enquiry updated successfully", "success");
      setShowModal(false);
      fetchEnquiries();
    } catch (error) {
      console.error("Error updating enquiry:", error);
      Swal.fire("Error", "Failed to update enquiry", "error");
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This enquiry will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteProductEnquiry/${id}`);
        Swal.fire("Deleted!", "Enquiry deleted.", "success");
        fetchEnquiries();
      } catch (error) {
        console.error("Error deleting enquiry:", error);
        Swal.fire("Error", "Failed to delete enquiry", "error");
      }
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="mb-2">
            <h4 className="text-start">All Product Enquiries</h4>

            {/* 🔍 Filter/Search Controls */}
            {loading ? (
              <div className="row g-2 mb-3">
                <div className="col-md-4"><Skeleton height={38} /></div>
                <div className="col-md-2"><Skeleton height={38} /></div>
                <div className="col-md-2"><Skeleton height={38} /></div>
                <div className="col-md-2"><Skeleton height={38} /></div>
              </div>
            ) : (
              <div className="row g-2 mb-3">
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name, Email, Phone, Message"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="Start Date"
                    className="form-control"
                  />
                </div>
                <div className="col-md-2">
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="End Date"
                    className="form-control"
                  />
                </div>
                <div className="col-md-2">
                  <button className="btn btnsuccess w-100" onClick={handleDownloadExcel}>
                    <Download size={17} />&nbsp;Download
                  </button>
                </div>
              </div>
            )}

            {/* 🧾 Table Section */}
            <div className="card">
              <div className="card-body" style={{ padding: 0 }}>
                <div style={{ overflowX: "auto", maxHeight: "500px" }}>
                  {loading ? (
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Message</th>
                          <th>Listing  </th>
                          <th>Seller</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(6)].map((_, i) => (
                          <tr key={i}>
                            <td><Skeleton width={25} /></td>
                            <td><Skeleton width={100} /></td>
                            <td><Skeleton width={120} /></td>
                            <td><Skeleton width={90} /></td>
                            <td><Skeleton width={150} /></td>
                            <td><Skeleton width={60} /></td>
                            <td><Skeleton width={60} /></td>
                            <td><Skeleton width={80} /></td>
                            <td><Skeleton width={80} /></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : filteredEnquiries.length === 0 ? (
                    <p className="text-center py-3 mb-0">No enquiries found.</p>
                  ) : (
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Message</th>
                          <th>Listing  </th>
                          <th>Seller</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEnquiries.map((e, index) => (
                          <tr key={e.id}>
                            <td>{index + 1}</td>
                            <td>{e.name}</td>
                            <td>{e.email}</td>
                            <td>{e.phone}</td>
                            <td style={{ whiteSpace: "pre-wrap" }}>{e.message}</td>
                            <td>{e.listing_title}</td>
                            <td>{e.first_name} {e.last_name}</td>
                            <td>{new Date(e.created_at).toLocaleString()}</td>
                            <td>
                              <div className="d-flex">
                                <button
                                  className="btn btn-sm btn-info me-1"
                                  onClick={() => openEditModal(e)}
                                >
                                  <Edit size={14} />
                                </button>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => handleDelete(e.id)}
                                >
                                  <Trash size={14} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>

            {/* ✏️ Edit Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Edit Enquiry</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3">
                  <label>Remark</label>
                  <textarea
                    className="form-control"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  ></textarea>
                </div>
                <div className="mb-3">
                  <label>Status</label>
                  <select
                    className="form-control"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="Active">Active</option>
                    <option value="Closed">Closed</option>
                  </select>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleEditSubmit}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAllEnquiry;
